export default {
    label: {
        veriscan: 'VeriScan',
        email: 'Email',
        password: 'Password',
        name: 'Name',
        title: 'Title',
        firstName: "First Name",
        middleName: "Middle Name",
        lastName: "Last Name",
        description: 'Description',
        address: 'Address',
        city: 'City',
        state: 'State',
        phone: 'Phone',
        permissions: 'Permissions',
        close: 'Close',
        cancel: 'Cancel',
        save: 'Save',
        welcome: 'Welcome',
        settings: 'Settings',
        logout: 'Logout',
        help: "Help",
        location: "Location",
        zip: "Zip Code",
        search: "Search",
        searchColName: "Search Name Column",
        dobColName: "Date of Birth Column",
        citizenshipColName: "Citizenship Column",
        ssnColName: "SSN",
        einColName: "EIN/TIN",
        licenseNumberColName: "Drivers License #",
        licenseCountryColName: "Drivers License Country",
        localIdColName: "Local ID",
        delimiter: "Delimiter",
        history: "History",
        resolution: "Case Resolution",
        comments: "Comments",
        caseGroups: "Case Groups",
        caseManager: "Case Manager",
        passport: "Passport",
        compliance: "Compliance",
        type: "Type",
        caseReport: "Case Report"
    },
    hint: {
        emailLogin: "Used to login",
        permissionsDoc: "See documentation here for details on user permissions",
        adminPasswordReset: "Only needed if resetting user password",
        caseGroups: "Case groups assignment for automatic ongoing screening",
        localId: "Optional. Must not match any other case's ID",
        whitelist: "Exclude this case from any future screening schedule by case group"
    },
    component: {
        sourceChips: {
            sdn: "SDN",
            dpl: "DPL",
            consolidated: "Consolidated OFAC",
            un: "UN Sec. Council",
            dfat: "Aus. DFAT",
            eu: "EU EEAS",
            pep: "PEP"
        },
        resultsPanel: {
            targetData: "Target Data",
            addresses: "Addresses",
            positions: "Positions",
            websites: "Websites",
            education: "Education"
        },
        id: {
            unknown: "Unknown ID Type",
            issued: "Issued",
            expiration: "Expiration"
        },
        caseReportComments: {
            placeholder: "Add a comment..."
        }
    },
    view: {
        login: {
            title: 'VeriScan v0.0.1',
            button: {
                login: 'Login',
                register: 'Register',
            },
            error: {
                invalid: "Invalid email or password. Please try again"
            }
        }, 
        register: {
            error: {
                creditCard: "There was an error processing your payment method. Please try again"
            }
        },
        unresolved: {
            title: "Unresolved Cases"
        },
        caseManager: {
            button: {
                whitelistOptions: "Whitelist Settings",
                whitelistOptionsTip: "Configure whitelisting settings for selected cases"

            },
            table: {
                caseGroups: "Groups"
            }
        },
        account: {
            paymentMethodUpdate: {
                success: "Payment method updated."
            }
        }
    },
    table: {
        caseReport: {
            actions: {
                updateStatus: {
                    title: "Update Status",
                    subTitle: "Update status of selected cases."
                }
            }
        }
    },
    modal: {
        addUser: {
            title: "Adding User",
            success: "New user created"
        },
        editUser: {
            title: "Editing User",
            success: "User updated"
        },
        updatePassword: {
            title: "Update Password"
        },
        editAccount: {
            title: "Editing Account"
        },
        updatePaymentMethod: {
            title: "Update Your Payment Method",
            cardError: "The has been a problem updating your payment method. Please contact support"
        },
        updateSubscription: {
            title: "Subscription Management"
        },
        csvSearch: {
            title: "Bulk Search Upload",
            subTitle: "Load CSV for simultanious seach",
            label: {
                upload: "Upload search file",
                csvOptions: "File Options"
            }
        },
        caseReport: {
            label: {
                resolutionStatus: "Resolution Status",
                unresolved: "Unresolved",
                resolvedProceed: "Cleared",
                resolvedClearedEnhanced: "Cleared - Enhanced",
                resolvedNoMatches: "Resolved - No Matches",
                resolvedDiscontinue: "Match Confirmed",
                flagged: "Flagged",
                flag: "Flag",
                approve: "Approve",
                resolve: "Resolve",
                resolvedOn: "Resolved On",
                resolutionComments: "Comments",
                resolveCase: "Resolve Case"
            }
        },
        multiResolution: {
            title: "Case Report Status",
            label: {
                status: "Status",
                commentOptional: "Comment - Optional"
            }
        },
        multiAssign: {
            title: "Assign Case Reports",
            subTitle: " case reports will be assigned",
            label: {
                assignee: "Assignee",
                commentOptional: "Comment - Optional"
            },
            alert: {
                success: "Case reports assigned."
            }
        },
        bulkWhitelist: {
            title: "Whitelist Cases",
            subtitle: " cases will be updated",
            tip: "Whitelisted cases will be excluded from any ongoing screening configured through their case groups."
        },
        addCaseGroup: {
            title: "Case Group Settings",
            subtitle: "Configure default assignee, screening frequency and email alerts"
        },
        addCase: {
            title: "Add New Case",
            label: {
                gender: "Gender",
                localId: "Local ID",
                dob: "Date of Birth",
                citizenship: "Citizenship",
                placeOfBirth: "Place of Birth",
                phoneNumber: "Phone Number",
                passportNumber: "Passport Number",
                passportCountry: "Country of Passport",
                licenseNumber: "Driver License Number",
                licenseCountry: "Driver License Country",
                ssn: "Social Security Number",
                taxId: "Tax ID", 
                address1: "Address Line 1",
                address2: "Address Line 2",
                address3: "Address Line 3",
                address4: "Address Line 4",
                city: "City",
                stateOrProvince: "State or Province",
                postalCode: "Postal Code",
                country: "Country",
                caseGroups: "Case Groups",
            }
        },
        updateCase: {
            title: "Update Case",
            label: {
                gender: "Gender",
                localId: "Local ID",
                dob: "Date of Birth",
                citizenship: "Citizenship",
                placeOfBirth: "Place of Birth",
                phoneNumber: "Phone Number",
                passportNumber: "Passport Number",
                passportCountry: "Country of Passport",
                licenseNumber: "Driver License Number",
                licenseCountry: "Driver License Country",
                ssn: "Social Security Number",
                taxId: "Tax ID", 
                address1: "Address Line 1",
                address2: "Address Line 2",
                address3: "Address Line 3",
                address4: "Address Line 4",
                city: "City",
                stateOrProvince: "State or Province",
                postalCode: "Postal Code",
                country: "Country",
                caseGroups: "Case Groups"
            }
        },
        editComplianceSettings: {
            title: "Compliance Settings"
        }
    },
    error: {
        general: {
            unhandled: "Sorry, there has been a problem. Please try again shortly."
        },
        register: {
            emailExists: "An account with that email address already exists."
        },
        caseGroups: {
            error: "Unable to retreive case groups, support has been notified."
        }

    },
    content:{
        help: {
            overview: {
                header: "About VeriScan",
                main: "VeriScan's individual and entity screening and search functions were designed in coordination with the U.S Department of the Treasury, based on latest guidelines which call for a fuzzy logic search. The search algorithm utilizes multiple matching techniques; Jaro-Winkler character similarity and Soundex phonetic matching. The search returns exact matches, as well as partial matches which meet a minimum threshold as defined by the user. The higher the threshold, the fewer results will be returned and the higher the likelihood of a match. For more information on the guidelines used, please visit Treasury Departments official guidelines"
            }
        }
    }
}